export default __webpack_public_path__ + "static/improvement-b0971c3ed1d1533f284d0c2cd8097933.png";